// Layout.jsx
import React from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '../context/ThemeContext.jsx';

const Layout = () => {
    return (
        <ThemeProvider>
            <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Header />
                <main style={{ flex: 1 }}>
                    <Outlet />
                </main>
                <Footer />
            </div>
        </ThemeProvider>
    );
};

export default Layout;